import { isFuture, isToday, subDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';

import UI from '../../common/UI';
import useLocale from '../../common/useLocale';

interface PaymentReminderInfoProps {
  dueDate: Date;
}

const PaymentReminderInfo = ({ dueDate }: PaymentReminderInfoProps) => {
  const { t } = useTranslation();
  const { formatDate } = useLocale();

  const reminders = sortBy(
    [
      subDays(dueDate, 30),
      subDays(dueDate, 14),
      subDays(dueDate, 1),
    ].filter((date) => isToday(date) || isFuture(date)),
    (reminder) => reminder.getTime(),
  );

  return (
    <UI.Info>
      {reminders.length > 0 && (
        <>
          <UI.Strong>{t('reminders_will_be_sent_on', { count: reminders.length })}</UI.Strong>
          <UI.UL>
            {reminders.map((date, index) => (
              <UI.LI key={index}>
                {formatDate(date, { format: 'display_date', timezone: null })}
              </UI.LI>
            ))}
          </UI.UL>
        </>
      )}
      {reminders.length === 0 && t('no_reminders_will_be_sent')}
    </UI.Info>
  );
};

export default PaymentReminderInfo;
